const KEYBOARD_OPEN_THRESHOLD_PX = 150

/**
 * Tracks mobile software keyboard via visualViewport.
 * Returns unsubscribe function.
 */
export function trackVisualKeyboard(onChange) {
  if (typeof window === 'undefined' || !window.visualViewport) {
    return () => {}
  }

  let maxViewportHeight = window.visualViewport.height

  const sync = () => {
    const height = window.visualViewport.height

    if (height > maxViewportHeight) {
      maxViewportHeight = height
    }

    // iOS animates the keyboard in several resizes. Each step is often
    // under the threshold, so do not lower the baseline until it is closed.
    const isOpen = maxViewportHeight - height > KEYBOARD_OPEN_THRESHOLD_PX

    onChange(isOpen)
  }

  // Safety net: some WebViews don't restore viewport height on keyboard close
  const onFocusOut = () => {
    setTimeout(() => {
      const tag = document.activeElement?.tagName
      if (tag !== 'INPUT' && tag !== 'TEXTAREA') {
        maxViewportHeight = Math.max(maxViewportHeight, window.visualViewport.height)
        onChange(false)
      }
    }, 100)
  }

  window.visualViewport.addEventListener('resize', sync)
  document.addEventListener('focusout', onFocusOut)

  return () => {
    window.visualViewport.removeEventListener('resize', sync)
    document.removeEventListener('focusout', onFocusOut)
  }
}
